export default {
	sectionTitle: {
		 en: 'Meet our speakers'
	},
	paragraph: {
		en: 'Your text goes here. Insert your content, thoughts, or information in this space.'
	}
};
